import { useCallback as y, useEffect as w } from "react";
import { isEditableInput as E } from "../isEditableInput.js";
import "../system/constants.js";
import { findBinding as b, toResolvedBinding as g } from "../system/matching.js";
import "../key/constants.js";
import { buildEventMatchKeyFromEvent as k } from "../system/keyboardEvent.js";
import { isPromiseLike as f, reportAsyncError as p, reportBindingError as l } from "./errors.js";
function x({
  system: c,
  effectiveScopeRef: s,
  getAction: d,
  onAction: i,
  onError: o
}) {
  const n = y(
    (t) => {
      if (t.repeat || t.defaultPrevented || E(t.target)) return;
      const a = k(t);
      if (!a) return;
      const u = s.current, e = b(c, u, a);
      if (!e) return;
      const m = d(e.id) ?? e.action;
      if (m) {
        if (t.preventDefault(), i)
          try {
            const r = i({
              binding: g(e),
              event: t,
              currentScope: u
            });
            f(r) && Promise.resolve(r).catch(p);
          } catch (r) {
            p(r);
          }
        try {
          const r = m();
          f(r) && Promise.resolve(r).catch((h) => {
            l(h, e, t, o);
          });
        } catch (r) {
          l(r, e, t, o);
        }
      }
    },
    [s, d, i, o, c]
  );
  w(() => (window.addEventListener("keydown", n), () => {
    window.removeEventListener("keydown", n);
  }), [n]);
}
export {
  x as useKeyboardListener
};
